import React, { Component } from "react";
import { FiChevronRight } from "react-icons/fi";
import { Modal, ModalBody } from "reactstrap";
import Swal from "sweetalert2";
import SimpleLabel from "../../../base/features/micro/SimpleLabel";
import {
  deleteTerm,
  editTermDetail,
  termDetail,
  termDetailSave,
} from "./services";

class TermDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageMode:
        window.location.pathname.split("/").length === 5 ? "edit" : "add",
      title: "",
      des: "",
      isActive: true,
      isLocationTerms: true,
      shopUid: window.location.pathname.split("/")[2],
      termId:
        window.location.pathname.split("/").length === 5 &&
        window.location.pathname.split("/")[4],
      acceptModal: false,
      pending: false,
      index: 0,
    };
  }
  componentDidMount() {
    if (this.state.pageMode === "edit") {
      this.getTermDetail();
    }
  }
  saveTerm() {
    this.setState({ pending: true });
    var params = {
      title: this.state.title,
      des: this.state.des,
      active: this.state.isActive,
      is_location_terms: this.state.isLocationTerms,
    };
    termDetailSave(this.state.shopUid, params).then((items) => {
      items &&
        (window.location.href = `/dashboard/${this.state.shopUid}/terms`);
    });
  }
  editTerm() {
    this.setState({ pending: true });
    var params = {
      title: this.state.title,
      des: this.state.des,
      active: this.state.isActive,
      is_location_terms: this.state.isLocationTerms,
    };
    editTermDetail(this.state.shopUid, this.state.termId, params).then(
      (items) => {
        items &&
          (window.location.href = `/dashboard/${this.state.shopUid}/terms`);
      }
    );
  }
  delete_term() {
    this.setState({ acceptModal: false, pending: true });
    deleteTerm(this.state.shopUid, this.state.termId).then((items) => {
      Swal.fire({
        text: "با موفقعیت حذف شد",
        icon: "success",
        timer: 2000,
        confirmButtonText: "تایید",
      }).then(
        () => (window.location.href = `/dashboard/${this.state.shopUid}/terms`)
      );
    });
  }
  getTermDetail() {
    termDetail(this.state.shopUid, this.state.termId).then((items) => {
      items &&
        this.setState({
          title: items.title,
          des: items.des,
          isActive: items.active,
          isLocationTerms: items.is_location_terms,
          index: items.index,
        });
    });
  }
  render() {
    return (
      <div className="container-fluid">
        <header
          className="row mx-0 px-3 py-2-3 position-fixed bg-white shadow-sm"
          style={{ top: "0", right: "0", left: "0" }}
        >
          <div className="col-auto align-self-center px-0">
            <FiChevronRight
              size="26"
              className=""
              onClick={() => window.history.back()}
            />
          </div>
          <div className="col text-center align-self-center px-0">
            <h1 className="fs-5 fw-bold mb-0">
              {this.state.pageMode === "add"
                ? "توضیحات تکمیلی جدید"
                : "ویرایش توضیحات تکمیلی"}
            </h1>
          </div>
          <div className="col-auto text-center align-self-center px-0">
            <button
              onClick={() =>
                this.state.pageMode === "add"
                  ? this.saveTerm()
                  : this.editTerm()
              }
              className="btn fs-6 p-0 fw-bold mb-0 color-main"
              disabled={
                !this.state.des || !this.state.title || this.state.pending
              }
            >
              {this.state.pending ? (
                <div className="spinner-border spinner-border-sm color-second align-middle"></div>
              ) : (
                "ذخیره"
              )}
            </button>
          </div>
        </header>
        <body style={{ marginTop: "62px" }}>
          <div className="row mx-0">
            <div className="col-12 px-0 my-3 position-relative">
              <input
                className="p-3 form-control rounded14"
                placeholder="عنوان"
                value={this.state.title}
                onChange={(e) => this.setState({ title: e.target.value })}
              />
              {this.state.title && <SimpleLabel text="عنوان" />}
            </div>
            <div className="col-12 px-0 my-3 position-relative">
              <textarea
                rows="4"
                className="p-3 form-control rounded14"
                placeholder="توضیحات"
                value={this.state.des}
                onChange={(e) => this.setState({ des: e.target.value })}
              />
              {this.state.des && <SimpleLabel text="توضیحات" />}
            </div>
            <div className="col-10 px-0 py-3">
              <p className="mb-0 fw-bolder">انتخاب به عنوان قوانین فروشگاه</p>
              <p className="small text-secondary mt-2 px-3">
                *قوانین فروشگاه علاوه بر صفحه فروشگاه در زمان خرید نیز به خریدار
                نمایش داده می شود.
              </p>
            </div>
            <div className="col-2 px-0 py-3 text-start">
              <input
                class="form-check-input mt-0 align-middle color-main"
                type="checkbox"
                name="checkbox-1"
                value={this.state.isLocationTerms}
                checked={this.state.isLocationTerms}
                onChange={() =>
                  this.setState({
                    isLocationTerms: !this.state.isLocationTerms,
                  })
                }
              />
            </div>
            <div className="col-10 px-0 py-3">
              <p className="mb-0 fw-bolder">فعال</p>
            </div>
            <div className="col-2 px-0 py-3 text-start">
              <input
                class="form-check-input mt-0 align-middle color-main"
                type="checkbox"
                name="checkbox-2"
                value={this.state.isActive}
                checked={this.state.isActive}
                onChange={() =>
                  this.setState({ isActive: !this.state.isActive })
                }
              />
            </div>
            <div className="col-10 px-0 py-3">
              <p className="mb-0 fw-bolder">ترتیب قرارگیری</p>
            </div>
            <div className="col-2 px-0 align-self-center text-start">
              <select class="form-select select-dropdown-none text-center bg-none px-4 py-2 w-auto d-inline-block">
                {this.props.location.state &&
                  this.props.location.state.terms.map((term, t) => (
                    <option
                      className="text-center"
                      selected={t === this.state.index}
                      value="1"
                    >
                      {t + 1}
                    </option>
                  ))}
                {this.props.location.state &&
                  this.props.location.state.terms &&
                  this.state.pageMode === "add" && (
                    <option
                      className="text-center"
                      selected={
                        this.props.location.state.terms.length + 1 ===
                        this.state.index
                      }
                      value="1"
                    >
                      {this.props.location.state.terms.length + 1}
                    </option>
                  )}
              </select>
            </div>
          </div>
          {this.state.pageMode === "edit" && (
            <div
              className="row mx-0 p-4 position-fixed border-top border-light"
              style={{ bottom: "0", left: "0", right: "0" }}
            >
              <div className="col-12 px-0">
                <button
                  className="btn rounded28 py-2-3 fw-bold border text-danger w-100"
                  onClick={() => this.setState({ acceptModal: true })}
                >
                  حذف قانون
                </button>
              </div>
            </div>
          )}
        </body>
        {this.state.acceptModal && (
          <Modal
            dir="rtl"
            zIndex="9999999"
            className="m-0"
            contentClassName="border-0 position-fixed fixed-bottom rounded-top-28 w-auto"
            isOpen={this.state.acceptModal}
            toggle={() => this.setState({ acceptModal: false })}
          >
            <ModalBody className="row mx-0 p-4">
              <div className="col-12 px-1 mb-3">
                <p className="fw-bolder">حذف توضیح تکمیلی</p>
                <p className="text-muted">
                  آیا از حذف توضیح تکمیلی فعلی اطمینان دارید؟
                </p>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 text-danger fw-bold"
                  onClick={() => this.delete_term()}
                >
                  بله
                </button>
              </div>
              <div className="col-6 px-1">
                <button
                  className="btn py-2 w-100 rounded28 border text-muted fw-bold"
                  onClick={() => this.setState({ acceptModal: false })}
                >
                  انصراف
                </button>
              </div>
            </ModalBody>
          </Modal>
        )}
      </div>
    );
  }
}

export default TermDetail;
